import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { rootRoute } from './root'

const ContactUs = lazyRouteComponent(() => import('../pages/contact-us'))

export const contactUsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'contact-us',
  component: ContactUs,
})
